export enum GuaranteesIssueGuaranteeFieldName {
  ManagementAccountingProduct = 'managementAccountingProduct',
  OperationProvidedDate = 'operationProvidedDate',
  OperationFinishedDate = 'operationFinishedDate',
}

export type TGuaranteesIssueGuaranteeFormValues = {
  [GuaranteesIssueGuaranteeFieldName.ManagementAccountingProduct]: string;
  [GuaranteesIssueGuaranteeFieldName.OperationProvidedDate]: string;
  [GuaranteesIssueGuaranteeFieldName.OperationFinishedDate]: string;
};
